<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <Head :title="`NFT: ${metaData.name}`">
        <meta name="description" :content="metaDescription" />

        <meta name="og:title" :content="metaData.name.substr(0, 70)" />
        <meta name="og:type" :content="website" />
        <meta name="og:image" :content="nft.localFileUrl" />
        <meta name="og:url" :content="route('nft', {nft: nft.id})" />
        <meta name="twitter:card" content="summary_large_image">

        <meta name="og:description" :content="metaData.description.substr(0, 255)" />
        <meta property="og:site_name" content="web3register.org by Foundervision AG">
        <meta name="twitter:image:alt" :content="metaData.name">
        <meta name="twitter:site" content="@web3register">
    </Head>

    <div class="bg-white">
        <div class="mt-3 mx-auto pt-8 pt-sm-4 px-4 grid grid-cols-1 gap-x-8 sm:px-6 sm:pt-4 pb-8 lg:max-w-7xl lg:px-8 lg:grid-cols-2">
            <div class="mt-4 mt-sm-0">
                <h2 class="text-2xl leading-5 font-medium text-gray-900 mb-2 block lg:hidden">{{ metaData.name }}</h2>
                <img :src="nft.localFileUrl" :alt="metaData.name" class="rounded-lg" id="nft-logo" />
                <canvas class="hidden" id="canvas"></canvas>
            </div>
            <div class="mt-4">
                <a v-for="(page, idx) in pages" :key="page.name" :href="page.href" class="text-xs font-medium mr-1">{{ page.name }} <span v-if="idx !== Object.keys(pages).length - 1">&raquo;</span></a>
                <div class="mt-2" v-if="nft.metaDataType === 'basic'">
                    <h2 class="text-base font-medium"><strong>{{ metaData.name }}</strong></h2>
                    <p class="mt-1 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces;" v-html="metaDescription"></p>
                </div>
                <div class="mt-2" v-if="nft.metaDataType === 'animal'">
                    <h2 class="text-base font-medium"><strong>{{ metaData.name }}</strong></h2>
                    <p class="mt-1 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces;" v-html="metaDescription"></p>
                </div>
                <div class="mt-2" v-if="nft.metaDataType === 'poem'">
                    <h2 class="text-base font-medium"><strong>{{ metaData.name }}</strong></h2>
                    <p class="mt-1 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces;" v-html="metaDescription"></p>
                </div>
                <div class="mt-2" v-if="nft.metaDataType === 'human-obituary'">
                    <h2 class="text-base font-medium"><strong>{{ metaData.name }}</strong></h2>
                    <p class="my-1 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces;">
                        {{ nft.metaFields.nameExtra.value }}
                    </p>
                    <div class="sm:col-span-2">
                        <dt class="text-sm font-medium">{{ nft.metaFields.dateOfBirth.label }}</dt>
                        <dd class="mt-1 text-sm">{{ nft.metaFields.dateOfBirth.value }}</dd>
                    </div>
                    <div class="sm:col-span-2">
                        <dt class="text-sm font-medium">{{ nft.metaFields.dateOfDeath.label }}</dt>
                        <dd class="mt-1 text-sm">{{ nft.metaFields.dateOfDeath.value }}</dd>
                    </div>

                    <p class="my-8 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces; border-left: 3px solid grey; padding-left: 10px;">
                        {{ nft.metaFields.spiritualMessage.value }}
                    </p>
                    <p class="mt-1 max-w-2xl text-sm text-gray-600" style="white-space: break-spaces;">{{ metaDescription }}</p>
                </div>
            </div>
        </div>
        <div class="mx-auto px-4 pt-4 flex justify-end align-items-end lg:max-w-7xl ">
            <twitter-button v-bind:isBlank="false" class="share-button--outline" btnText :url="nft.urlLocalized" :description="nft.metaName + ' - ' + nft.metaDescription" :title="nft.metaName" />
            <facebook-button v-bind:isBlank="false" class="share-button--outline" btnText :url="nft.urlLocalized" :description="nft.metaName + ' - ' + nft.metaDescription" :title="nft.metaName" />
            <linked-in-button v-bind:isBlank="false" class="share-button--outline" btnText :url="nft.urlLocalized" :description="nft.metaName + ' - ' + nft.metaDescription" :title="nft.metaName"/>
            <whats-app-button v-bind:isBlank="false" class="share-button--outline" btnText :url="nft.urlLocalized" :description="nft.metaName + ' - ' + nft.metaDescription" :title="nft.metaName"/>
            <reddit-button v-bind:isBlank="false" class="share-button--outline" btnText :url="nft.urlLocalized" :description="nft.metaName + ' - ' + nft.metaDescription" :title="nft.metaName"/>
        </div>
        <div class="mx-auto pt-8 px-4 grid grid-cols-1 gap-x-8 sm:px-6 sm:pt-4 pb-8 lg:max-w-7xl lg:px-8" v-if="!showDetails">
            <div class="flex items-start justify-start">
                <button @click="showDetails = true">&raquo; {{ translate('nft.showMore') }}</button>
            </div>
        </div>
        <div class="mx-auto pt-8 px-4 grid grid-cols-1 gap-x-8 sm:px-6 sm:pt-4 pb-8 lg:max-w-7xl lg:px-8" v-if="showDetails">
            <div>
                <div class="border-t mt-5 pt-3">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <img class="h-6 w-6" src="/img/transparent_logomark_black.png" alt="" />
                        </div>
                        <div class="ml-4">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">Web 3.0 Register</h3>
                            <p class="text-xs text-gray-500">
                                <a href="https://web3register.org">https://web3register.org</a>
                            </p>
                        </div>
                    </div>
                    <hr class="mt-3" />
                    <div class="px-0 py-5 sm:px-10">
                        <dl class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2">
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.w3rWebAddress')}}</dt>
                                <dd class="mt-1 text-sm text-blue-500 underline truncate"><a :href="route('nft', {nft: nft.id })" target="_blank">{{ route('nft', {nft: nft.id }) }}</a></dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.w3rImageAddress')}}</dt>
                                <dd class="mt-1 text-sm text-blue-500 underline truncate"><a :href="nft.localFileUrl" target="_blank">{{nft.localFileUrl}}</a></dd>
                            </div>
                            <div class="sm:col-span-2 text-right">
                                <button type="button" @click="downloadQr()" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    {{translate('nft.qrCode')}}
                                    <QrCodeIcon class="ml-2 -mr-0.5 h-4 w-4" aria-hidden="true" />
                                </button>
                            </div>
                        </dl>
                    </div>
                </div>
                <div class="border-t pt-3">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <img class="h-6 w-6" src="/img/polygon-matic-logo.svg" alt="" />
                        </div>
                        <div class="ml-4">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">Polygon</h3>
                            <p class="text-xs text-gray-500">
                                <a href="https://polygon.technology" target="_blank">https://polygon.technology</a>
                            </p>
                        </div>
                    </div>
                    <hr class="mt-3" />
                    <div class="px-0 py-5 sm:px-10">
                        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4"  v-if="polygonCommit === null">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <ExclamationIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-yellow-700">
                                        {{translate('nft.notRegistered')}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <dl class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2" v-if="polygonCommit !== null">
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.smartContract')}}</dt>
                                <dd class="mt-1 text-sm text-gray-600 underline truncate"><a :href="polygonCommit.contractLink" target="_blank">{{polygonCommit.contract}}</a></dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.transaction')}}</dt>
                                <dd class="mt-1 text-sm text-gray-600 underline truncate">
                                    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4"  v-if="polygonCommit.commitId === null">
                                        <div class="flex">
                                            <div class="flex-shrink-0">
                                                <ExclamationIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                                            </div>
                                            <div class="ml-3">
                                                <p class="text-sm text-yellow-700">
                                                    {{translate('nft.registrationRunning')}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <a :href="polygonCommit.commitIdLink" target="_blank"  v-if="polygonCommit.commitId !== null">{{polygonCommit.commitId}}</a>
                                </dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">Token ID</dt>
                                <dd class="mt-1 text-sm text-gray-600 underline truncate"><a :href="polygonCommit.tokenLink" target="_blank">{{nft.tokenId}}</a></dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <div class="border-t pt-3">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <img class="h-6 w-6" src="/img/ipfs-logo.svg" alt="" />
                        </div>
                        <div class="ml-4">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">IPFS</h3>
                            <p class="text-xs text-gray-500">
                                <a href="https://ipfs.io/" target="_blank">https://ipfs.io/</a>
                            </p>
                        </div>
                    </div>
                    <hr class="mt-3" />
                    <div class="px-0 py-5 sm:px-10">
                        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4" v-if="nft.ipfsHash === null || polygonCommit === null">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <ExclamationIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm text-yellow-700">
                                        {{translate('nft.notRegistered')}}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <dl class="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2" v-if="nft.ipfsHash !== null && polygonCommit !== null">
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.fileCID')}}</dt>
                                <dd class="mt-1 text-sm text-gray-600 underline truncate"><a :href="nft.ipfsHashLink" target="_blank">{{nft.ipfsHash}}</a></dd>
                            </div>
                            <div class="sm:col-span-2">
                                <dt class="text-sm font-medium">{{translate('nft.metaCID')}}</dt>
                                <dd class="mt-1 text-sm text-gray-600 underline truncate"><a :href="nft.ipfsMetaDataHashLink" target="_blank">{{nft.ipfsMetaDataHash}}</a></dd>
                            </div>
                        </dl>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import { AtSymbolIcon } from "@heroicons/vue/24/solid";
import {computed, onMounted, ref} from "vue";
import { HomeIcon } from '@heroicons/vue/24/solid'
import { QrCodeIcon } from '@heroicons/vue/24/solid'
import { PaperClipIcon } from '@heroicons/vue/24/solid'
import QrCodeWithLogo from 'qrcode-with-logos';
import { Head } from '@inertiajs/inertia-vue3'
import translate from "../../lang";
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import LinkedInButton from "vue-share-buttons/src/components/LinkedInButton";
import RedditButton from "vue-share-buttons/src/components/RedditButton";
import WhatsAppButton from "vue-share-buttons/src/components/WhatsAppButton";

export default {
    props: {
        nft: Object,
        commit: Object,
        metaData: Object,
        metaDescription: String,
    },
    components:{
        TwitterButton,
        FacebookButton,
        LinkedInButton,
        RedditButton,
        WhatsAppButton,
        HomeIcon,
        PaperClipIcon,
        QrCodeIcon,
        Head
    },
    setup(props) {
        const pages = [
            { name: 'NFTs', href: '/', current: false },
            { name: translate()('global.types.' + props.nft.metaDataType), href: '/', current: false },
        ]

        let downloadQr = function() {
            let qrCode = new QrCodeWithLogo({
                canvas: document.getElementById("canvas"),
                content: window.location.href,
                download: false,
                width: 1000,
                logo: {
                    src: "/img/transparent_logomark_black.png"
                }
            });

            qrCode.toCanvas().then(() => {
                qrCode.toImage().then(() => {
                    qrCode.downloadImage(props.nft.id + ' QR Code.png');
                });
            });
        }

        const polygonCommit = props.commit;

        let showDetails = ref(false);
        return {
            pages,
            polygonCommit,
            downloadQr,
            translate: translate(),
            showDetails,
        }
    },
}
</script>
